import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { BaseDeRefService } from '@shared/services/cabinet/basederef.service';
import { SiretService } from '@shared/services/siret/siret.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);
  const dialog = inject(MatDialog);

  let token;
  if (req.url.startsWith(environment.apiUrl.baseref)) {
    token = inject(BaseDeRefService).getTokenFromLocal();
  } else if (req.url.startsWith(environment.apiUrl.siret)) {
    token = inject(SiretService).getTokenFromLocal();
  } else {
    token = inject(AuthService).getAuthToken();
  }

  let newReq = req;
  if (token) {
    let headers = req.headers;
    headers = headers.append('Authorization', `Bearer ${token}`);
    headers = headers.append('X-WEB', '1');
    newReq = req.clone({
      headers,
    });
  }
  return next(newReq).pipe(
    catchError((err) => {
      if (err.status === 401 && token) {
        snackBar.open('Vous avez été déconnecté.', 'Ok');
        dialog.closeAll();
        localStorage.clear();
        router.navigate(['signin']);
      }
      return throwError(() => err);
    }),
  );
};
